import { PUBLIC_API_BASE_URL, PUBLIC_WEBSITE_SLUG } from "@/utils/publicApiConfig";

export { PUBLIC_API_BASE_URL, PUBLIC_WEBSITE_SLUG };

export const buildApiHeaders = (): Record<string, string> => ({
  "Content-Type": "application/json",
});

export const handleApiError = (error: unknown, response?: Response): string => {
  if (response) {
    switch (response.status) {
      case 403:
        return "Access denied. This site origin may not be whitelisted on the server.";
      case 404:
        return "Website or section not found.";
      case 500:
        return "Server error. Please try again later.";
      default:
        return `API request failed with status ${response.status}.`;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return "An unexpected error occurred.";
};

/**
 * POST/GET to public website API paths (contact, analytics, json-public, etc.).
 * Same pattern as other CoreTechs Vite apps (e.g. scandi-matsal `makePublicRequest`).
 */
export const makePublicRequest = async (
  endpoint: string,
  options: RequestInit = {},
): Promise<Response> => {
  const base = PUBLIC_API_BASE_URL.replace(/\/$/, "");
  const url = endpoint.startsWith("http")
    ? endpoint
    : `${base}${endpoint.startsWith("/") ? "" : "/"}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    headers: {
      ...buildApiHeaders(),
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(handleApiError(null, response));
  }

  return response;
};

/** Fire-and-forget variant for analytics (never throws to callers). */
export const postPublicEvent = (endpoint: string, body: unknown): void => {
  void makePublicRequest(endpoint, {
    method: "POST",
    body: JSON.stringify(body),
  }).catch(() => {
    // Analytics must never break the site.
  });
};
